<!-- 教育局-学校开课统计 -->
<template>
  <div class="container">
    <div class="index">
      <div class="title">
        <span>{{ $route.name }}</span>
        <span style="font-weight: normal;
         margin-left: 70%;
        color:#606266;font-size:14px;">截止日期:{{dayjs(new Date().getTime()-86400000).format('YYYY-MM-DD')}}</span>
      </div>

      <header>
        <div class="header-item" style="width: 25%">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>学校开课统计</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item" style="width: 25%">
          <div class="header-item-title" style="height: 24px"></div>
          <div id="echarts-box2"></div>
        </div>

        <div class="header-item" style="width: 20%">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>课程报名率统计</span>
          </div>
          <div id="echarts-box3"></div>
        </div>

        <div class="header-item" style="width: 30%">
          <div class="header-item-title" style="height: 24px"></div>
          <div id="echarts-box4"></div>
        </div>
      </header>

      <div class="header-item-title">
        <span class="circle"></span>
        <span>开课数统计明细</span>
      </div>

      <div class="query m-t">
        <el-form ref="form" :inline="true" :model="form" label-width="90px">
          <el-form-item label="">
            <el-select
              v-model="form.schoolYearSemester1"
              placeholder="选择学年学期"
              clearable
              @clear="searchFun1()"
            >
              <el-option
                v-for="item in semesterList"
                :key="item.id"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="">
            <el-select v-model="courseType" clearable placeholder="课程分类">
              <el-option
                v-for="item in courseTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="">
            <el-button type="primary" size="small" @click="searchFun1"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData_1"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            v-if="!educationType"
            align="center"
            prop="orga_name"
            label="区域"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            v-else
            align="center"
            prop="orga_name"
            label="学校"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column align="center" prop="total" label="总计">
               <template slot-scope="scope">
                    {{ numFilter(scope.row.total)}}
               </template>
          </el-table-column>
          <el-table-column align="center" prop="go_org_num" label="学校课程数">
          </el-table-column>
          <el-table-column align="center" prop="go_orga_num" label="遴选机构课程数">
          </el-table-column>
          <el-table-column align="center" prop="task_org_num" label="作业辅导">
          </el-table-column>
          <el-table-column align="center" prop="acc_org_num" label="素养课程">
          </el-table-column>
          <el-table-column align="center" prop="an_org_num" label="社团活动">
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page1.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page1.pageSize"
        :total="page1.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle1"
        @current-change="currentChangeHandle1"
      ></el-pagination>
      <!--  -->
      <!--  -->
      <!--  -->
      <div class="header-item-title">
        <span class="circle"></span>
        <span>报名率统计明细</span>
      </div>

      <div class="query m-t">
        <el-form ref="form" :inline="true" label-width="90px">
          <el-form-item label="">
            <el-select
              v-model="form.schoolYearSemester2"
              placeholder="选择学年学期"
              clearable
              @clear="searchFun2()"
            >
              <el-option
                v-for="item in semesterList"
                :key="item.id"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="">
            <el-select v-model="q" clearable placeholder="课程分类">
              <el-option
                v-for="item in courseTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="">
            <el-button type="primary" size="small" @click="searchFun2"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData_2"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            v-if="!educationType"
            align="center"
            prop="orga_name"
            label="区域"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            v-else
            align="center"
            prop="orga_name"
            label="学校"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column align="center" prop="total" label="总数">
               <template slot-scope="scope">
                    {{ numFilter(scope.row.total)}}
               </template>
          </el-table-column>
          <el-table-column align="center" prop="re_per_td" label="学校课程报名率">
               <template slot-scope="scope">
                    {{ numFilter(scope.row.re_per_td)}}
               </template>
          </el-table-column>
          <el-table-column align="center" prop="rec_per_td" label="机构课程报名率">
                <template slot-scope="scope">
                    {{ numFilter(scope.row.rec_per_td)}}
               </template>
          </el-table-column>
          <el-table-column align="center" prop="recr_per_td" label="作业辅导报名率">
               <template slot-scope="scope">
                    {{ numFilter(scope.row.recr_per_td)}}
               </template>
          </el-table-column>
          <el-table-column align="center" prop="recru_per_td" label="素养课程报名率">
             <template slot-scope="scope">
                    {{ numFilter(scope.row.recru_per_td)}}
               </template>
          </el-table-column>
          <el-table-column align="center" prop="recrui_per_td" label="社团活动报名率">
              <template slot-scope="scope">
                    {{ numFilter(scope.row.recrui_per_td)}}
               </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page2.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page2.pageSize"
        :total="page2.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle2"
        @current-change="currentChangeHandle2"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  handleCurriculumProvide,
  handleCurriculumType,
  handleEnrollmentRatet,
  handleSignUpType,
  handleOpenClassList,
  handleSignUpList,
} from "@/api/education/statistical.js";
import dayjs from 'dayjs';
import * as echarts from "echarts";
import util from '@/utils/util.js'; 
export default {
  components: {},
  data() {
    return {
      form: {
        schoolYearSemester1: "",
        schoolYearSemester2: "",
        courseType: "",
      },
      page1: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      page2: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      CurriculumTypeData:[
                { value: 0, name: "作业辅导" },
                { value: 0, name: "素养课程" },
                { value: 0, name: "社团活动" },
              ],
                    curriculumProvideData:[
                { value: 0, name: "学校课程数" },
                { value: 0, name: "机构课程数" },
              ],
      tableData_1: [],
      tableData_2: [],
      courseTypeList: JSON.parse(sessionStorage.getItem("courseTypeList")) || [
        { id: "type1", name: "作业辅导" },
        { id: "type2", name: "科普" },
        { id: "type3", name: "文体" },
        { id: "type4", name: "艺术" },
        { id: "type5", name: "劳动" },
        { id: "type6", name: "阅读" },
        { id: "type7", name: "兴趣小组" },
        { id: "type8", name: "社团活动" },
        { id: "type9", name: "其他" },
      ],
      qList: [],
      // semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      semesterList: [
        { id: "xq1", label: "2021-2022学年下学期" },
        { id: "xq2", label: "2021-2022学年上学期" },
        { id: "xq3", label: "2020-2021学年下学期" },
        { id: "xq4", label: "2020-2021学年上学期" },
        { id: "xq5", label: "2019-2020学年下学期" },
        { id: "xq6", label: "2019-2020学年上学期" },
      ],
      dateTime: "",
      educationType: sessionStorage.getItem("educationType") === "area",
      Userlist: JSON.parse(window.sessionStorage.getItem("Userlist")),
      erollmentRatetData:[],
      SignUpTypeData:[],
    };
  },
  mounted() {
    this.getData();
  },
  computed: {},
  created() {},
  methods: {
     dayjs,
     numFilter(val){
      return  util.numFilter(val)
     },
    async getData() {
      this.getNowDate()
      this.getCurriculumProvide();
      this.getCurriculumType();
      this.getEnrollmentRatet();
      this.getSignUpType();
      this.getOpenClassList();
      this.getSignUpList();
    },
    async getCurriculumProvide() {
      try {
        let params = {
          date: this.dateTime, //统计日期,
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          prd_name: "", //学段名称 小学
          yearly_semester: "", //2021-2022学年上学期
          platform_code: sessionStorage.getItem("platformCode"),//必传
          school_year: "2021-2022",//必传 学年
          term: "2",//必传 学期
        };
        let { code, data } = await handleCurriculumProvide(params);
        if (code === "0") {
          if (data.rows && data.rows.length != 0) {
               this.curriculumProvideData[0].value=data.rows[0].go_org_num
              this.curriculumProvideData[1].value=data.rows[0].go_orga_num
          } 
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.init();
      }
    },
     async getCurriculumType() {
      try {
        let params = {
          date: this.dateTime, //统计日期,
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          prd_name: "", //学段名称 小学
          yearly_semester: "", //2021-2022学年上学期
        };
        let { code, data } = await handleCurriculumType(params);
        if (code === "0") {
          if (data.rows && data.rows.length != 0) {
              this.CurriculumTypeData[0].value=data.rows[0].task_org_num
              this.CurriculumTypeData[1].value=data.rows[0].acc_org_num
              this.CurriculumTypeData[2].value=data.rows[0].an_org_num
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.init();
      }
    },
    async getEnrollmentRatet() {
      try {
        let params = {
          date: this.dateTime, //统计日期,
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          prd_name: "", //学段名称 小学
          yearly_semester: "", //2021-2022学年上学期
        };
        let { code, data } = await handleEnrollmentRatet(params);
        if (code === "0") {
          if (data.rows && data.rows.length != 0) {
               this.erollmentRatetData=[data.rows[0].re_per_td===null?0:data.rows[0].re_per_td,data.rows[0].rec_per_td===null?0:data.rows[0].rec_per_td]
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.init();
      }
    },
     async getSignUpType() {
      try {
        let params = {
          date: this.dateTime, //统计日期,
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          prd_name: "", //学段名称 小学
          yearly_semester: "", //2021-2022学年上学期
        };
        let { code, data } = await handleSignUpType(params);
        if (code === "0") {
          if (data.rows && data.rows.length != 0) {
               this.SignUpTypeData=[data.rows[0].recr_per_td===null?0:data.rows[0].recr_per_td,data.rows[0].recru_per_td===null?0:data.rows[0].recru_per_td,data.rows[0].recrui_per_td===null?0:data.rows[0].recrui_per_td]
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.init();
      }
    },
    async getOpenClassList() {
      try {
        let params = {
          date: this.dateTime, //统计日期,
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          prd_name: "", //学段名称 小学
          yearly_semester: this.form.schoolYearSemester1, //2021-2022学年上学期
          platform_code: sessionStorage.getItem("platformCode"),//必传
          school_year:this.form.schoolYearSemester1==''?'':this.form.schoolYearSemester1.slice(0,9),//必传
          term:this.form.schoolYearSemester1==''?'': this.form.schoolYearSemester1.slice(11,12),//必传
          pagenum:this.page1.pageNum,
          pagesize:this.page1.pageSize,
        };
        let { code, data } = await handleOpenClassList(params);
        if (code === "0") {
          if (data.rows && data.rows.length != 0) {
              this.tableData_1= data.rows
              this.page1.totalPage=data.total
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.init();
      }
    },
    async getSignUpList() {
      try {
        let params = {
          date: this.dateTime, //统计日期,
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          prd_name: "", //学段名称 小学
          yearly_semester: this.form.schoolYearSemester2, //2021-2022学年上学期
          pagenum:this.page2.pageNum,
          pagesize:this.page2.pageSize,

        };
        let { code, data } = await handleSignUpList(params);
        if (code === "0") {
          if (data.rows && data.rows.length != 0) {
              this.tableData_2= data.rows
              this.page2.totalPage=data.total
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.init();
      }
    },
    searchFun1() {
      console.log('进行查询--',this.form.schoolYearSemester1);
      
      this.page1.pageNum = 1;
      this.getOpenClassList();
    },
    sizeChangeHandle1(val) {
      this.tableData_1 = [];
      this.page1.pageSize = val;
      this.getData();
    },
    currentChangeHandle1(val) {
      this.tableData_1 = [];
      this.page1.pageNum = val;
      this.getData();
    },
     searchFun2() {
      this.page2.pageNum = 1;
      this.getSignUpList();
    },
    sizeChangeHandle2(val) {
      this.tableData_2 = [];
      this.page2.pageSize = val;
      this.getData();
    },
    currentChangeHandle2(val) {
      this.tableData_2 = [];
      this.page2.pageNum = val;
      this.getData();
    },
    // 获取当前一天的数据
    getNowDate() {
      this.dateTime = util.getNowDate();
    },
    init() {
      let vm = this;
      this.$nextTick(() => {
        // 圆环图
        let chartDom1 = document.getElementById("echarts-box1");
        let myChart1 = echarts.init(chartDom1);
        let option1 = {
          legend: {
            left: "center",
            top: "bottom",
            icon: "circle",
          },
           tooltip: {
            trigger: "item",
            axisPointer: {
              type: "shadow", 
            },
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["61%", "78%"], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 0,
                borderColor: "#fff",
                borderWidth: 0,
              },
              label: {
                show: false,
                position: "center",
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: "16",
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: false,
              },
              data: [
                { value: 160, name: "学校课程数" },
                { value: 198, name: "遴选机构课程数" },
              ],
            },
          ],
          // 圆环颜色
          color: ["#5BB0FF", "#51D6A6"],
        };
        myChart1.setOption(option1);

        // 圆环图
        let chartDom2 = document.getElementById("echarts-box2");
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          legend: {
            left: "center",
            top: "bottom",
            icon: "circle",
          },
          tooltip: {
            trigger: "item",
            axisPointer: {
              type: "shadow", 
            },
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["61%", "78%"], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 0,
                borderColor: "#fff",
                borderWidth: 0,
              },
              label: {
                show: false,
                position: "center",
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: "16",
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: false,
              },
              data:this.CurriculumTypeData
            },
          ],
          // 圆环颜色
          color: ["#5BB0FF", "#51D6A6", "#757FFD"],
        };
        myChart2.setOption(option2);

        // 柱状图
        let chartDom3 = document.getElementById("echarts-box3");
        let myChart3 = echarts.init(chartDom3);
        let option3 = {
          grid: {
            height: 200,
            top: 36,
            left: 42,
          },
          xAxis: {
            type: "category",
            data: ["学校\n课程数", "机构\n课程数"],
            axisLine: {
              //坐标线
              lineStyle: {
                type: "solid",
                color: "#DDDDDD", //轴线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: "#999999", //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: "value",
          },
          tooltip: {
            trigger: "axis",
            //  formatter: "{axis}%",
            axisPointer: {
              type: "shadow",
            },
             formatter: '<strong>{b0}</strong> <br /> <span style="display: inline-block; margin-right: 4px; border-radius: 10px; width: 10px; height: 10px;background-color: #5BB0FF;"></span> 报名率：<strong>{c0}%</strong> <br />'
          },
          series: [
            {
              data: this.erollmentRatetData,
              type: "bar",
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: "none", //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: "#5BB0FF" },
                  ]),
                  label: {
                    formatter: "{c}%",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999",
                    },
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart3.setOption(option3);

        // 柱状图
        let chartDom4 = document.getElementById("echarts-box4");
        let myChart4 = echarts.init(chartDom4);
        let option4 = {
          grid: {
            height: 200,
            top: 36,
            left: 42,
          },
          xAxis: {
            type: "category",
            data: ["作业辅导", "素养课程", "社团活动"],
            axisLine: {
              //坐标线
              lineStyle: {
                type: "solid",
                color: "#DDDDDD", //轴线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: "#999999", //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: "value",
          },
          tooltip: {
            trigger: "axis",
            //  formatter: "{axis}%",
            axisPointer: {
              type: "shadow",
            },
            formatter: '<strong>{b0}</strong> <br /> <span style="display: inline-block; margin-right: 4px; border-radius: 10px; width: 10px; height: 10px;background-color: #5BB0FF;"></span> 报名率：<strong>{c0}%</strong> <br />'
          },
          series: [
            {
              data:this.SignUpTypeData,
              type: "bar",
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: "none", //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: "#5BB0FF" },
                  ]),
                  label: {
                    formatter: "{c}%",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999",
                    },
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart4.setOption(option4);
      });
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  width: 189px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}

header {
  width: 100%;
  height: 350px;
  display: flex;
  .header-item {
    width: 50%;
    .header-item-text {
      font-size: 14px;
      color: #666;
      padding-left: 20px;
      margin-top: 5px;
    }
  }
  #echarts-box1,
  #echarts-box2 {
    width: 70%;
    height: 280px;
  }
  #echarts-box3,
  #echarts-box4 {
    width: 90%;
    height: 280px;
  }
}
.header-item-title {
  font-size: 18px;
  color: #333;
  display: flex;
  align-items: center;
  .circle {
    width: 8px;
    height: 8px;
    display: inline-block;
    background: #4991e1;
    border-radius: 50%;
    margin-right: 10px;
  }
}
</style>
